/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-01-08 14:45:21
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2021-03-30 14:11:19
 */
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

// import createPersistedState from 'vuex-persistedstate' // 防止页面刷新vuex数据消失

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  // plugins: [createPersistedState({ storage: window.sessionStorage })],
  modules,
  getters
})

export default store
